import React, { useEffect, useState } from 'react';
import './App.css';
import Router from './router/router';
import { RouterProvider } from 'react-router-dom';
import { useUserDetails } from './react-query/hooks/HHomePage';
import { useAppDispatch } from './redux/hooks/hooks';
import { updateUserDetails } from './redux/reducer/user.reducer';
import { Helmet } from "react-helmet";
import { InteractionStatus, IPublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from './services/msalAuth/authConfig';
import Navbar from './components/navbar';
import "./utils/theme/_sizes.scss"

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {

  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {

    const hasConsented = sessionStorage.getItem('cookieConsent');
    if (hasConsented) {
      setConsentGiven(true);
    } else {

      const script = document.createElement('script');
      script.id = "cookieWrapper";
      script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
      script.charset = "UTF-8";
      script.setAttribute('data-domain-script', "cfe68b18-5bf6-4646-ab37-ec219d50a02f");
      script.innerHTML = `function OptanonWrapper() { }`;
      document.body.appendChild(script);

      sessionStorage.setItem('cookieConsent', 'true');
      setConsentGiven(true);
    }
  }, []);

  if (inProgress === InteractionStatus.None && !isAuthenticated) {
    sessionStorage.setItem('authHandler', '1')
    instance.loginRedirect(loginRequest)
      .catch((error: any) => {
        console.log(error)
      });
  }

  return (
    <div className='w-full h-full flex flex-nowrap'>
      <AuthenticatedTemplate>
        {!consentGiven && (
          <Helmet>
            <script
              id="cookieWrapper"
              src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
              charSet="UTF-8"
              data-domain-script="cfe68b18-5bf6-4646-ab37-ec219d50a02f"
            >
              function OptanonWrapper() { }
            </script>
          </Helmet>
        )}
        <Router />
      </AuthenticatedTemplate>
    </div>
  );
}

export default App;
